import { call, put, takeLatest } from "redux-saga/effects"
import axios from "axios"
import { map, find } from "lodash"
import { push } from "connected-react-router"
import {
  HAS_DIVISIONS_WATCHER,
  SEARCH_COLLABORATORS_WATCHER,
  GET_TEMPLATE_COLLABORATORS_WATCHER,
  UPLOAD_TEMPLATE_COLLABORATORS_WATCHER,
  GET_COLLABORATORS_WATCHER,
  HAS_COLLABORATORS_WATCHER,
  GET_TEAM_WATCHER,
  ASSIGN_LEADER_WATCHER,
  GET_POTENTIAL_LEADERS_WATCHER,
  GET_TEAM_POTENTIAL_WATCHER,
  ADD_EMPLOYEES_TEAM_WATCHER,
  REMOVE_EMPLOYEES_TEAM_WATCHER,
  REMOVE_COLLABORATORS_WATCHER,
  GET_MEASURES_WATCHER,
  GET_VISMA_PEOPLE_STATUS_WATCHER,
} from "./constants"
import {
  hasDivisionsSucces,
  getTemplateCollaboratorsSuccess,
  getTemplateCollaboratorsFailed,
  uploadTemplateCollaboratorsFailed,
  uploadTemplateCollaboratorsSuccess,
  getCollaboratorsSuccess,
  getCollaboratorsFailed,
  searchCollaboratorsSuccess,
  searchCollaboratorsFailed,
  hasCollaboratorsSuccess,
  hasCollaboratorsFailed,
  getTeamFailed,
  getMeasuresSuccess,
  getMeasuresFailed,
  getTeamSuccess,
  getPotentialLeadersSuccess,
  getPotentialLeadersFailed,
  hasCollaboratorsWatcher,
  searchCollaboratorsWatcher,
  getTeamPotentialSuccess,
  getTeamPotentialFailed,
  getTeamPotentialWatcher,
  assignLeaderSuccess,
  hasSegmentsSuccess,
  getVismaPeopleStatusSuccess,
  getVismaPeopleStatusFailed,
} from "./actions"
import { exportCollaboratorSegment } from "../../utils/segment/Employee/employeeTrack"
import {
  KEY_TIMESTAMP_COLLABORATORS_IMPORT,
  LOCAL_COMPANY_ID,
  LOCAL_TOKEN,
  setItem,
} from "../../utils/storage"

function messageProgress(messagex) {
  message.loading(messagex, 0)
}

function messageSuccess(messagex) {
  message.success(messagex, 5)
}

function messageFailed(messagex) {
  message.error(messagex, 5)
}

function messageDestroy() {
  message.destroy()
}


export function getVismaPeopleStatusApi() {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}companies/${LOCAL_COMPANY_ID()}/synchronizations/status`,
  })
}


// GET COLLABORATORS
export function getCollaboratorsApi() {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}companies/${LOCAL_COMPANY_ID()}/employees`,
  })
}

export function getCollaboratorsApiPaginated(data) {
  
  let url = `${process.env.API_URL}v2/companies/${LOCAL_COMPANY_ID()}/employees?page=${data.payload.page}&perPage=${data.payload.perPage}`;
  if (data.payload.sortField) {
    url += `&sortField=${data.payload.sortField}`;
  }
  
  if (data.payload.sortOrder) {
    url += `&sortOrder=${data.payload.sortOrder}`;
  }
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: url,
  });
}
export function getCountTeams() {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/employees/count/teams`,
  })
}

export function* getCollaborators(action) {
  try {
    const { data, status } = yield call(getCollaboratorsApi)
    const countTeams = yield call(getCountTeams)

    const dataParsed = map(data.data, (item) => {
      if (
        find(
          countTeams.data.data,
          (countTeam) => countTeam.id_employee === item.id_employee
        )
      ) {
        return {
          ...item,
          team: find(
            countTeams.data.data,
            (countTeam) => countTeam.id_employee === item.id_employee
          ),
        }
      }

      return item
    })

    if (status === 200) {
      yield put(getCollaboratorsSuccess(dataParsed))
    }
  } catch (error) {
    yield put(getCollaboratorsFailed())
    returnMessage(error)
  }
}


export function* getCollaboratorsPaginated(action) {
  try {
    
    const { data, status } = yield call(getCollaboratorsApiPaginated,action)
    let pagination = {
      data: data.data,
      current_page : data.current_page,
      per_page : data.per_page,
      total : data.total,
      leaders: data.leaders,
      divisions: data.divisions,
      segments: data.segments,
      employees_without_division_visma_people: data.employees_without_division_visma_people
    }
    
    if (status === 200) {
      yield put(getCollaboratorsSuccess(pagination))
    }
  } catch (error) {
    yield put(getCollaboratorsFailed())
    returnMessage(error)
  }
}


// SEARCH COLLABORATORS
export function searchCollaboratorsApi(data) {
  let filter = null;
  let url = `${process.env.API_URL}v2/companies/${LOCAL_COMPANY_ID()}/employees`;

  if (typeof data === 'string') {
    if (data) {
      filter = {
        "filter[searchEmployeeByColumsTable]": data,
        // 'filter[searchDivisionAmbassador]': value
      };
      url += `?page=1&perPage=15`;
    }
  } else {
    url += `?page=${data.current}&perPage=${data.pageSize}`;

    if (data.sortField) {
      url += `&sortField=${data.sortField}`;
    }

    if (data.sortOrder) {
      url += `&sortOrder=${data.sortOrder}`;
    }

    // Incluir el filtro de búsqueda si está presente en el objeto
    if (data.searchText && data.searchText.trim() !== '') {
      filter = {
        "filter[searchEmployeeByColumsTable]": data.searchText,
      };
    }

    if (Array.isArray(data.divisions) && data.divisions.length > 0) {
      const divisionsParam = data.divisions.map(division => `divisions[]=${encodeURIComponent(division)}`).join('&');
      url += `&${divisionsParam}`;
    }

    if (Array.isArray(data.leaders) && data.leaders.length > 0) {
      const leadersParam = data.leaders.map(leader => `leaders[]=${encodeURIComponent(leader)}`).join('&');
      url += `&${leadersParam}`;
    }
    if (Array.isArray(data.segments) && data.segments.length > 0) {
      const segmentsParam = data.segments.map(segment => `segments[]=${encodeURIComponent(segment)}`).join('&');
      url += `&${segmentsParam}`;
    }
    if (data.searchText) {
      filter = { "filter[searchEmployeeByColumsTable]": data.searchText };
    }
  }

  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: url,
    params: filter,
  });
}

export function* searchCollaborators(action) {
  try {
    const { data, status } = yield call(searchCollaboratorsApi, action.payload)
    
    let pagination = {
      data: data.data,
      current_page : data.current_page,
      per_page : data.per_page,
      total : data.total,
      leaders: data.leaders,
      divisions: data.divisions,
      segments: data.segments
    }
    
    if (status === 200) {
      yield put(searchCollaboratorsSuccess(pagination))
    }
  } catch (error) {
    yield put(searchCollaboratorsFailed())
  }
}

// GET EXCEL
export function getTemplateCollaboratorsApi(isTemplate) {
  const template = isTemplate ? "/template" : ""
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/employees/export/xlsx${template}`,
  })
}

function getTemplateCollaboratorsApiProgress() {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/employees/export/xlsx/progress`,
  })
}

function donwloadTemplateCollaborators(url) {
  location.replace(url)
}

export function* getTemplateCollaboratorsWatcher(action) {
  const listCollaborator = yield call(getCollaboratorsApi)
  try {
    yield call(
      messageProgress,
      action.payload ? "Descargando plantilla" : "Descargando archivo"
    )

    yield call(getTemplateCollaboratorsApi, action.payload)
    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 1000))
      data = yield call(getTemplateCollaboratorsApiProgress)
      if (data.status === 200) {
        break
      }
    }
    yield call(donwloadTemplateCollaborators, data.data[0].url)
    yield call(messageDestroy)

    yield call(
      messageSuccess,
      action.payload
        ? getStatusCollaboratorExistExport(
            "Plantilla descargada",
            listCollaborator
          )
        : getStatusCollaboratorExistExport(
            "Archivo descargado",
            listCollaborator
          )
    )

    yield put(getTemplateCollaboratorsSuccess())
  } catch (error) {
    yield call(messageDestroy)

    yield call(
      messageFailed,
      action.payload
        ? getStatusCollaboratorExistExport(
            "Error al descargar la plantilla",
            listCollaborator
          )
        : getStatusCollaboratorExistExport(
            "Error al descargar archivo",
            listCollaborator
          )
    )

    yield put(getTemplateCollaboratorsFailed())
  }
}

function getStatusCollaboratorExistExport(status, listCollaborator) {
  exportCollaboratorSegment(
    status,
    "exportEmployees",
    listCollaborator && listCollaborator.status === 200
      ? listCollaborator.data.data.length
      : ""
  )
  return status
}

// UPLOAD EXCEL
function uploadTemplateCollaborators(payload) {
  return axios.request({
    method: "post",
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/employees/import/xlsx`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    data: payload,
  })
}

function uploadTemplateCollaboratorsProgress(payload) {
  return axios.request({
    method: "get",
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/employees/import/xlsx/progress`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    params: payload,
  })
}

export function* uploadTemplateCollaboratorsWatcher(action) {
  try {
    const mode = action.payload
    
    yield call(messageProgress, "Cargando archivo")
    let data_response = yield call(uploadTemplateCollaborators, action.payload)
    setItem(KEY_TIMESTAMP_COLLABORATORS_IMPORT, data_response.data.timestamp)
    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 1000))

      data = yield call(uploadTemplateCollaboratorsProgress, {
        timestamp: data_response.data.timestamp,
      })

      if (data.status === 200) {
        break
      }
    }

    yield call(messageDestroy)
    yield call(messageSuccess, "Archivo importado")
    yield put(uploadTemplateCollaboratorsSuccess())
    yield put(push("/organization/collaborators/summary?screen=collaborators"))
  } catch (error) {
    yield put(uploadTemplateCollaboratorsFailed())
    yield call(messageDestroy)
    yield call(messageFailed, "Error al importar archivo")
  }
}

// HAS DIVISIONS
function hasDivisionsApi() {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}companies/${LOCAL_COMPANY_ID()}/has/divisions`,
  })
}

export function* hasDivisionsSaga() {
  try {
    const { data, status } = yield call(hasDivisionsApi)

    if (status === 200) {
      yield put(hasDivisionsSucces(data.hasData))
    }
  } catch (e) {}
}

// HAS COLLABORATORS
function hasCollaboratorsApi() {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}companies/${LOCAL_COMPANY_ID()}/has/employees`,
  })
}

export function* hasCollaboratorsSaga() {
  try {
    const { data, status } = yield call(hasCollaboratorsApi)

    if (status === 200) {
      yield put(hasCollaboratorsSuccess(data.hasData))
      yield put(hasSegmentsSuccess(data.hasSegments))
    }
  } catch (e) {
    yield put(hasCollaboratorsFailed(false))
  }
}

// GET TEAM
function getTeamApi(idCollaborator) {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}employees/${idCollaborator}/team`,
  })
}

export function* getTeamSaga(action) {
  try {
    const { data, status } = yield call(getTeamApi, action.payload)

    if (status === 200) {
      yield put(getTeamSuccess(data.data))
    }
  } catch (e) {
    yield put(getTeamFailed())
  }
}

// GET POTENTIAL LEADERS
export function getPotentialLeadersApi(idCollaborator) {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}employees/${idCollaborator}/teamleader/potential`,
  })
}

export function* getPotentialLeadersSaga(action) {
  try {
    const { data, status } = yield call(getPotentialLeadersApi, action.payload)

    if (status === 200) {
      yield put(getPotentialLeadersSuccess(data.data))
    }
  } catch (error) {
    yield put(getPotentialLeadersFailed())
    returnMessage(error)
  }
}

// ASSIGN LEADER
export function assignLeaderApi({ idLeader, idEmployee }) {
  return axios.request({
    method: "POST",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}employees/${idLeader}/teamleader`,
    data: { id_employee: idEmployee },
  })
}

export function* assignLeaderSaga(action) {
  try {
    const { data, status } = yield call(assignLeaderApi, action.payload)

    if (status === 200) {
      yield put(searchCollaboratorsWatcher(action.payload.search_data))
      yield put(assignLeaderSuccess())
      yield call(messageSuccess, data.data.msj)
    }
  } catch (error) {
    returnMessage(error)
  }
}

// GET TEAM POTENTIAL
export function getTeamPotentialApi(idCollaborator) {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}employees/${idCollaborator}/team/potential`,
  })
}

export function* getTeamPotentialSaga(action) {
  try {
    const { data, status } = yield call(getTeamPotentialApi, action.payload)

    if (status === 200) {
      yield put(getTeamPotentialSuccess(data.data))
    }
  } catch (error) {
    yield put(getTeamPotentialFailed())
  }
}

// ADD EMPLOYEES TEAM
export function addEmployeesTeamApi({ idCollaborator, payload }) {
  return axios.request({
    method: "POST",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}employees/${idCollaborator}/team?${payload}`,
  })
}

export function* addEmployeesTeamSaga(action) {
  try {
    const { data, status } = yield call(addEmployeesTeamApi, action.payload)

    if (status === 200) {
      const params = { payload: action.payload.idCollaborator }

      yield put(searchCollaboratorsWatcher(action.payload.search_data))
      yield put(getTeamPotentialWatcher(action.payload.idCollaborator))
      yield call(getTeamSaga, params)
      yield call(messageSuccess, data.data.msj)
    }
  } catch (error) {
    const {
      response: { data },
    } = JSON.parse(JSON.stringify(error))
  }
}

// REMOVE EMPLOYEES TEAM
export function removeEmployeesTeamApi({ idLeader, payload }) {
  return axios.request({
    method: "DELETE",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}employees/${idLeader}/team?${payload}`,
  })
}

export function* removeEmployeesTeamSaga(action) {
  try {
    const { data, status } = yield call(removeEmployeesTeamApi, action.payload)

    if (status === 200) {
      const params = { payload: action.payload.idLeader }

      yield put(searchCollaboratorsWatcher(action.payload.search_data))
      yield put(getTeamPotentialWatcher(action.payload.idLeader))
      yield call(getTeamSaga, params)
      yield call(messageSuccess, data.data.msj)
    }
  } catch (error) {}
}

// REMOVE COLLABORATORS
export function removeCollaboratorsApi(payload) {
  return axios.request({
    method: "DELETE",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}employees/${payload}`,
  })
}

export function* removeCollaboratorsSaga(action) {
  try {
    
    const { data, status } = yield call(removeCollaboratorsApi, action.payload.id_employee)

    if (status === 200) {
      yield put(searchCollaboratorsWatcher(action.payload.search_data))
      yield call(messageSuccess, data.data.msj)
      yield put(hasCollaboratorsWatcher())
    }
  } catch (error) {
    yield put(getCollaboratorsFailed(""))
    const {
      response: { data },
    } = JSON.parse(JSON.stringify(error))
    yield call(messageFailed, data.data.error)
  }
}

// GET MEASURES
export function getMeasuresApi(payload) {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url:
      payload.length == 1
        ? `${process.env.API_URL}employees/${payload}/measures`
        : `${process.env.API_URL}employees/measures/${payload}`,
  })
}

export function* getMeasuresSaga(action) {
  try {
    const { data, status } = yield call(getMeasuresApi, action.payload)

    if (status === 200) {
      yield put(getMeasuresSuccess(data.data))
    }
  } catch (e) {
    yield put(getMeasuresFailed())
  }
}


export function* getVismaPeopleStatusSaga(action) {
  try {
    const { data, status } = yield call(getVismaPeopleStatusApi)

    if (status === 200) {
      yield put(getVismaPeopleStatusSuccess(data.data))
    }
  } catch (e) {
    console.log(e)
    yield put(getVismaPeopleStatusFailed())
  }
}

export default function* getDivisionWatcherSaga() {
  yield takeLatest(REMOVE_COLLABORATORS_WATCHER, removeCollaboratorsSaga)
  yield takeLatest(REMOVE_EMPLOYEES_TEAM_WATCHER, removeEmployeesTeamSaga)
  yield takeLatest(ADD_EMPLOYEES_TEAM_WATCHER, addEmployeesTeamSaga)
  yield takeLatest(GET_TEAM_POTENTIAL_WATCHER, getTeamPotentialSaga)
  yield takeLatest(GET_POTENTIAL_LEADERS_WATCHER, getPotentialLeadersSaga)
  yield takeLatest(ASSIGN_LEADER_WATCHER, assignLeaderSaga)
  yield takeLatest(HAS_COLLABORATORS_WATCHER, hasCollaboratorsSaga)
  yield takeLatest(GET_TEAM_WATCHER, getTeamSaga)
  yield takeLatest(HAS_DIVISIONS_WATCHER, hasDivisionsSaga)
  yield takeLatest(SEARCH_COLLABORATORS_WATCHER, searchCollaborators)
  yield takeLatest(GET_COLLABORATORS_WATCHER, getCollaboratorsPaginated)
  yield takeLatest(
    GET_TEMPLATE_COLLABORATORS_WATCHER,
    getTemplateCollaboratorsWatcher
  )
  yield takeLatest(
    UPLOAD_TEMPLATE_COLLABORATORS_WATCHER,
    uploadTemplateCollaboratorsWatcher
  )
  yield takeLatest(GET_MEASURES_WATCHER, getMeasuresSaga)
  yield takeLatest(GET_VISMA_PEOPLE_STATUS_WATCHER, getVismaPeopleStatusSaga)
}
